import { AnyAction } from '@reduxjs/toolkit';
import { ClassificationLayersStatus } from '../../service/common/constants';

const initState: {
  fields: any[];
} = {
  fields: [],
};

const reducer = (state = initState, action: AnyAction) => {
  switch (action.type) {
    case 'CLEAR_SF_FIELD_REQUESTED': {
      return {
        ...state,
        fields: [],
      };
    }
    case 'GET_FIELDS_SCENARIOS_REQUESTED': {
      return {
        ...state,
        fieldListState: { lifeCycle: 'PENDING' },
        fieldListParams: action.params,
      };
    }
    case 'GET_FIELDS_SCENARIOS_SUCCEEDED': {
      return {
        ...state,
        fieldListState: { lifeCycle: 'SUCCESS' },
        fields: action.payload,
      };
    }
    case 'GET_FIELDS_SCENARIOS_ERROR': {
      return {
        ...state,
        fieldListState: { lifeCycle: 'ERROR' },
        fields: [],
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_REQUESTED': {
      return {
        ...state,
        classificationLayers: undefined,
        classification_data: undefined,
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_SUCCEEDED': {
      return {
        ...state,
        classificationLayers: action.payload.layers,
        classification_data: action.payload.classification_data,
        classificationState: ClassificationLayersStatus.SUCCESS,
        processedFields: action.payload.processed,
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_UNAVAILABLE': {
      return {
        ...state,
        classificationState: ClassificationLayersStatus.UNAVAILABLE,
        classification_data: undefined,
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_LOADING': {
      return {
        ...state,
        classificationState: ClassificationLayersStatus.LOADING,
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_GENERATING': {
      return {
        ...state,
        classificationState: ClassificationLayersStatus.GENERATING,
      };
    }
    case 'GET_CLASSIFICATION_LAYERS_ERRORED': {
      return {
        ...state,
        classificationLayers: action.payload.layers,
        classification_data: undefined,
        classificationState: ClassificationLayersStatus.ERROR,
      };
    }
  }
  return state;
};

export default reducer;
